<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ title }}
          </h3>
          <cash-hero-box-tools-action />
        </div>
        <div class="box-body">
          <div class="row">
            <div
              class="col-xs-12"
              v-if="amount !== null && total !== null"
            >
              <cash-hero-table-with-chart
                :title-primary="secondLabel"
                :current-amount="currentAmount"
                :previous-amount="previousAmount"
                :current-total="currentTotal"
                :previous-total="previousTotal"
                :title-secondary="firstLabel"
              />
            </div>
            <div class="col-xs-12">
              <highcharts :options="chartOptions" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CashHeroBoxToolsAction from '../../../components/CashHeroBoxToolsAction'
import CashHeroTableWithChart from './CashHeroTableWithChart'

export default {
  name: 'CashHeroApplicantChart',
  components: {
    CashHeroTableWithChart,
    CashHeroBoxToolsAction
  },
  props: {
    title: {
      type: String,
      required: true
    },
    firstLabel: {
      type: String,
      required: true
    },
    secondLabel: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      amount: null,
      total: null,
      currentAmount: 0,
      currentTotal: 0,
      previousAmount: 0,
      previousTotal: 0,
      chartOptions: {
        width: '100%',

        title: {
          text: this.title
        },
        xAxis: [
          {
            categories: []
          }
        ],
        yAxis: [
          {
            gridLineWidth: 1,
            labels: {
              format: '{value} $',
              style: {
                color: 'black'
              }
            },
            title: {
              text: 'Dollar of applicants',
              style: {
                color: 'black'
              }
            },
            opposite: true
          },
          {
            gridLineWidth: 0,
            title: {
              text: 'Applicant',
              style: {
                color: 'black'
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: 'black'
              }
            },
            opposite: false
          }
        ],
        tooltip: {
          shared: true
        },
        colors: ['blue', 'gold'],
        series: [
          {
            name: 'Applicant',
            type: 'spline',
            yAxis: 1,
            data: [],
            tooltip: {
              valueSuffix: ' Applicants'
            }
          },
          {
            name: 'Dollar of applicants',
            type: 'spline',
            data: [],
            tooltip: {
              valueSuffix: ' $'
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      type: state => state.dashboard.buttonGroupActive,
      daterange: state => state.dashboard.daterange
    })
  },
  watch: {
    '$i18n.locale' () {
      if (this.chartOptions && this.chartOptions.title && this.chartOptions.title.text) {
        this.chartOptions.title.text = this.title
      }
    },
    type () {
      this.getApplicantChart()
    },
    daterange () {
      this.getApplicantChart()
    }
  },
  methods: {
    getApplicantChart () {
      let params = {}
      if (this.daterange && this.daterange[0] !== null && this.daterange[1] !== null) {
        params = {
          type: 'daterange',
          start_date: this.$moment(this.daterange[0]).locale('en').format('YYYY-MM-DD'),
          end_date: this.$moment(this.daterange[1]).locale('en').format('YYYY-MM-DD')
        }
      } else {
        params = {
          type: this.type.value.toUpperCase()
        }
      }
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/report/dashboard/get-applicant-chart', params)
        .then((response) => {
          if (response.data.code === 1) {
            this.chartOptions.series = response.data.data.series
            this.chartOptions.xAxis[0].categories = response.data.data.categories

            const series = response.data.data.series
            this.total = series[0].data
            this.amount = series[1].data

            if (Array.isArray(this.amount) && this.amount.length >= 2) {
              if (params.hasOwnProperty('start_date')) {
                this.previousAmount = 0
                this.currentAmount = this.amount.reduce((total, item) => total + item, 0)
              } else {
                this.previousAmount = this.amount[this.amount.length - 2]
                this.currentAmount = this.amount[this.amount.length - 1]
              }
            } else {
              this.previousAmount = 0
              this.currentAmount = this.amount[0]
            }

            if (Array.isArray(this.total) && this.total.length >= 2) {
              if (params.hasOwnProperty('start_date')) {
                this.previousTotal = 0
                this.currentTotal = this.total.reduce((total, item) => total + item, 0)
              } else {
                this.previousTotal = this.total[this.total.length - 2]
                this.currentTotal = this.total[this.total.length - 1]
              }
            } else {
              this.currentTotal = this.total[0]
              this.previousTotal = 0
            }
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
    }
  },
  mounted () {
    if (this.type) {
      this.getApplicantChart()
    }
  }
}
</script>

<style scoped>

</style>
